export default __webpack_public_path__ + "c76464cba67eff599e2fb63c91eeccc3.png";